import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faSkype,
  faSquareXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./footer.css";

function Footer() {
  const socialIcon = [
    {
      icon: faFacebook,
      link: "https://www.facebook.com/Explooration/",
    },
    {
      icon: faInstagram,
      link: "https://www.instagram.com/explooration/",
    },
    {
      icon: faLinkedin,
      link: "https://www.linkedin.com/company/explooration/",
    },
    {
      icon: faSkype,
      link: "https://www.skype.com/", // add real skype link if needed
    },
    {
      icon: faSquareXTwitter,
      link: "https://twitter.com/explooration", // adjust if you have
    },
  ];

  return (
    <div className="footerContainer">
      <h1>
        Expl<span style={{ color: "#F7D22D" }}>oo</span>ration
      </h1>

      <div className="iconSocialContainer">
        {socialIcon.map((item, id) => (
          <div className="iconSocial" key={id}>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="social-link"
            >
              <button>
                <FontAwesomeIcon icon={item.icon} />
              </button>
            </a>
          </div>
        ))}
      </div>

      <h3>
        Copyright <FontAwesomeIcon icon={faCopyright} /> 2025 All Rights
        Reserved.
      </h3>
    </div>
  );
}

export default Footer;
